import { Component } from '@angular/core';

interface Server {
  type: string;
  name: string;
}

@Component({
  selector: 'app-build-in',
  templateUrl: './build-in.component.html',
  styleUrls: ['./build-in.component.css']
})
export class BuildInComponent {
  servers: Server[] = [
    {
      type: 'Dropped',
      name: 'twitter.com',
    },
    {
      type: 'Proxy',
      name: 'google.com',
    },
    {
      type: 'Directly',
      name: 'yandex.com',
    },
    {
      type: 'Directly',
      name: '127.0.0.1',
    },
    {
      type: 'Proxy',
      name: 'google.com',
    },
  ];
} 